/*
*
* JS which is executed for both Desktop and Mobile
*
 */

let loop = true;

while (loop) {
	loop = false;

	if (document.querySelector('.venue__header-accordion')) {
		document.querySelectorAll('.venue__header-accordion').forEach(header => {
			header.addEventListener('click', function(event) {
				// Prevent click from triggering when clicking the button itself
				if (event.target.closest('button')) {
					return;
				}

				let button = this.querySelector('button[data-bs-toggle]');
				if (button) {
					button.click();
				}
			});
		});
	}
}